export default "__VITE_ASSET__BY6gK0ql__"